import React, { useEffect, useState } from "react";
import { FaWhatsapp } from "react-icons/fa";
import { IoCall } from "react-icons/io5";
import { getCustomerEnquiry } from "../../services/storeApi";
import { SyncLoader } from "react-spinners";
import { createEnquiry } from "../../services/adminApi";
import pattern from '../../assets/images/pattern-bg-2.png'

export default function BEFModal({ collections }) {
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [formData, setFormData] = useState({
        name: "",
        phone: "",
        company: "",
        city: "",
        productType: "",
        message: "",
    });
    const [errors, setErrors] = useState({});

    // 🧠 Handle input change
    const handleChange = (e) => {
        const { id, value } = e.target;
        setFormData((prev) => ({ ...prev, [id]: value }));
        setErrors((prev) => ({ ...prev, [id]: "" })); // Clear error as user types
    };

    // ✅ Validation Function
    const validate = () => {
        const newErrors = {};

        if (!formData.name.trim()) newErrors.name = "Name is required";

        if (!formData.phone.trim()) {
            newErrors.phone = "Phone number is required";
        } else if (!/^[6-9]\d{9}$/.test(formData.phone)) {
            newErrors.phone = "Enter a valid 10-digit Indian phone number";
        }

        if (!formData.city) newErrors.city = "Please select your city";

        if (!formData.productType)
            newErrors.productType = "Please select a product category";

        if (formData.message.trim().length < 10)
            newErrors.message = "Message should be at least 10 characters";

        return newErrors;
    };

    // 📨 Submit handler
    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        const validationErrors = validate();

        if (Object.keys(validationErrors).length > 0) {
            setIsSubmitting(false);
            setErrors(validationErrors);
            return;
        }

        try {
            await getCustomerEnquiry(formData);
            setIsSubmitting(false);
            alert("Thank you! We’ve received your enquiry and will respond within 24 hours.");
            await createEnquiry(formData);
        } catch (error) {
            setIsSubmitting(false);
            alert("Sorry can't sent the information, please try with another email!")
            console.log("Some error occured", error)
        }
    };

    return (
        <>
            <div className="bg-light mt-5 w-100 p-sm-3 overflow-hidden"
                // style={{
                //     background: "url('../../assets/images/pattern-bg-3.png') no-repeat center center / cover",
                // }}
            >
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-8 col-md-10 col-sm-12">
                            <h3 className="text-uppercase mt-5 text-center">Bulk Order Enquiry Form</h3>

                            <div className="bg-white px-3 mb-5 mt-3 py-4 border border-2 shadow-sm rounded-3">
                                {/* --- Form --- */}
                                <form onSubmit={handleSubmit} noValidate>
                                    <div className="row g-3 my-1">
                                        <div className="col-md-6">
                                            <label htmlFor="name" className="form-label small mb-1">
                                                Name
                                            </label>
                                            <input
                                                type="text"
                                                id="name"
                                                value={formData.name}
                                                onChange={handleChange}
                                                className={`form-control  ${errors.name ? "is-invalid" : ""
                                                    }`}
                                                placeholder="Your Name"
                                            />
                                            {errors.name && (
                                                <div className="invalid-feedback">{errors.name}</div>
                                            )}
                                        </div>

                                        <div className="col-md-6">
                                            <label htmlFor="phone" className="form-label small mb-1">
                                                Phone
                                            </label>
                                            <input
                                                type="tel"
                                                id="phone"
                                                value={formData.phone}
                                                onChange={handleChange}
                                                className={`form-control  ${errors.phone ? "is-invalid" : ""
                                                    }`}
                                                placeholder="Your Mobile"
                                            />
                                            {errors.phone && (
                                                <div className="invalid-feedback">{errors.phone}</div>
                                            )}
                                        </div>
                                    </div>

                                    {/* Company & City */}
                                    <div className="row g-3 mb-4 mt-2">
                                        <div className="col-md-6">
                                            <label htmlFor="company" className="form-label small mb-1">
                                                Company Name
                                            </label>
                                            <input
                                                type="text"
                                                id="company"
                                                value={formData.company}
                                                onChange={handleChange}
                                                className="form-control "
                                                placeholder="Store / Brand Name"
                                            />
                                        </div>
                                        <div className="col-md-6">
                                            <label htmlFor="city" className="form-label small mb-1">
                                                City
                                            </label>
                                            <select
                                                id="city"
                                                value={formData.city}
                                                onChange={handleChange}
                                                className={`form-select ${errors.city ? "is-invalid" : ""
                                                    }`}
                                            >
                                                <option value="">Select City</option>
                                                <option>Delhi</option>
                                                <option>Mumbai</option>
                                                <option>Bangalore</option>
                                                <option>Chennai</option>
                                                <option>Other</option>
                                            </select>
                                            {errors.city && (
                                                <div className="invalid-feedback">{errors.city}</div>
                                            )}
                                        </div>
                                    </div>

                                    {/* Product Type */}
                                    <div className="my-4">
                                        <label
                                            htmlFor="productType"
                                            className="form-label small mb-1"
                                        >
                                            Product Type
                                        </label>
                                        <select
                                            id="productType"
                                            value={formData.productType}
                                            onChange={handleChange}
                                            className={`form-select  ${errors.productType ? "is-invalid" : ""
                                                }`}
                                        >
                                            <option value="">Select Category</option>
                                            {collections.map((collection, index) => (
                                                <option key={index}>{collection.title}</option>
                                            ))}
                                        </select>
                                        {errors.productType && (
                                            <div className="invalid-feedback">{errors.productType}</div>
                                        )}
                                    </div>

                                    {/* Message */}
                                    <div className="my-4">
                                        <label htmlFor="message" className="form-label small mb-1">
                                            Short Message
                                        </label>
                                        <textarea
                                            id="message"
                                            value={formData.message}
                                            onChange={handleChange}
                                            className={`form-control  ${errors.message ? "is-invalid" : ""
                                                }`}
                                            rows="3"
                                            placeholder="Your requirement..."
                                            style={{ height: '200px' }}
                                        ></textarea>
                                        {errors.message && (
                                            <div className="invalid-feedback">{errors.message}</div>
                                        )}
                                    </div>

                                    {/* Submit */}
                                    <div className="mt-4">
                                        <button
                                            type="submit"
                                            className="btn btn-dark btn-lg text-uppercase px-4 w-100"
                                        >
                                            {!isSubmitting ? "Submit Enquiry" : <SyncLoader color="#ffffff" />}
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
